import { render, staticRenderFns } from "./LeftNavBase.vue?vue&type=template&id=f54d4002&scoped=true&"
import script from "./LeftNavBase.vue?vue&type=script&lang=js&"
export * from "./LeftNavBase.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavBase.vue?vue&type=style&index=0&id=f54d4002&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54d4002",
  null
  
)

export default component.exports